export default "__VITE_ASSET__BEDEpsNA__"